import { useState } from "react";
import includes from "lodash/includes";
import Select from "ui/molecules/Select";
import SingleTable from "ui/organisms/SingleTable";
import { UserBusinessUnits } from "types";
import Checkbox from "ui/molecules/Checkbox";

const BusinessSelection = ({
  id,
  name,
  label,
  formik,
  tableRows,
  businesses,
  checkboxName,
  businessesSelected,
  setBusinessesSelected,
}: any) => {
  const [isVisible, setIsVisible] = useState(false);
  const addingBusinessUnits = (item: any) => {
    const businessUnitMapped: UserBusinessUnits = {
      businessUnitId: item.businessUnitId,
      businessUnitDescription: item.fullName,
    };
    const existInTheList = includes(businessesSelected, businessUnitMapped);
    if (!existInTheList) {
      setBusinessesSelected([...businessesSelected, businessUnitMapped]);
    }
  };

  const removingBusinessUnits = (item: any) => {
    const newList = businessesSelected.filter(
      (businessSelected: UserBusinessUnits) => businessSelected.businessUnitId !== item.businessUnitId
    );
    setBusinessesSelected(newList);
    if (newList.length === 0) {
      formik.setFieldValue(id, "", false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const businessSelected = businesses.find((unit: any) => unit.businessUnitId === event.target.value);
    addingBusinessUnits(businessSelected);
  };

  const onSelectAllBusiness = (isChecked: boolean) => {
    setIsVisible(isChecked);
    if (isChecked) {
      const businessUnitsMapped = businesses.map((business: any) => ({
        businessUnitId: business.businessUnitId,
        businessUnitDescription: business.fullName,
      }));
      setBusinessesSelected(businessUnitsMapped);
      return;
    }
    setBusinessesSelected([]);
    formik.setFieldValue(name, "", false);
  };

  return (
    <>
      {!isVisible && (
        <Select
          id={id}
          name={name}
          label={label}
          margin='normal'
          mapValue='fullName'
          //disabled={isDisabled}
          mapKey='businessUnitId'
          value={formik.values.businesses}
          onChange={(selectedOption: any) => {
            handleChange(selectedOption);
            formik.handleChange(selectedOption);
          }}
          dataSource={businesses}
          error={formik.touched.businesses && Boolean(formik.errors.businesses)}
          helperText={formik.touched.businesses && formik.errors.businesses}
        />
      )}
      <>
        <Checkbox
          formik={formik}
          name={checkboxName}
          label='Seleccionar todas las sedes'
          onChangeCallback={onSelectAllBusiness}
        />
        {businessesSelected.length > 0 && (
          <SingleTable
            rows={tableRows}
            maxHeight={350}
            tableKeyToMap='businessUnitId'
            dataSource={businessesSelected}
            handleDelete={removingBusinessUnits}
            tableValueToMap='businessUnitDescription'
          />
        )}
      </>
    </>
  );
};

export default BusinessSelection;
